module.exports = __webpack_public_path__ + "@/assets/img/en.f4cc0b5e.svg";